import React from 'react';
import { FaCcVisa, FaCcMastercard, FaCcAmex, FaCcDiscover, FaCreditCard } from 'react-icons/fa';

interface CardTypeIconProps {
  cardType: string | null;
  size?: number;
}

function CardTypeIcon({ cardType, size = 24 }: CardTypeIconProps) {
  const normalizedType = cardType?.toLowerCase() ?? '';

  if (normalizedType.includes('visa')) {
    return <FaCcVisa size={size} color="#1A1F71" title="Visa" />;
  }

  if (normalizedType.includes('master') || normalizedType.includes('mc')) {
    return <FaCcMastercard size={size} color="#EB001B" title="Mastercard" />;
  }

  if (normalizedType.includes('amex') || normalizedType.includes('american')) {
    return <FaCcAmex size={size} color="#006FCF" title="American Express" />;
  }

  if (normalizedType.includes('discover')) {
    return <FaCcDiscover size={size} color="#FF6000" title="Discover" />;
  }

  return <FaCreditCard size={size} color="#6c757d" title="Card" />;
}

export default CardTypeIcon;
